import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import TableContainer from 'components/molecules/MbTable';

import { adexTransmitStatistics } from 'lib/api/adex';
import { getAdexUserList } from 'lib/api/adex';

import FilterWrap from 'components/atoms/FilterWrap';
import MbSelectbox from 'components/molecules/MbSelectbox';
import StatisticsCommonFilter from 'components/organisms/StatisticsCommonFilter';

let initialization = false;
// 공통 필터에서 초기값 받아왔는지 확인
let getInitParam = false;
const TransmitStatistics = () => {
  const { t } = useTranslation();
  const [userIndex, setUserIndex] = useState(null);
  const [userFilterList, setUserFilterList] = useState([]);

  let initParam = {
    type: 'advrtsAmt',
    userId: 'widerplanet',
  };

  const [params, setParams] = useState(initParam);

  useEffect(() => {
    // eslint-disable-next-line\
    getAdexUserData();
  }, []);

  useEffect(() => {
    // 렌더링 후에 실행됨
    // params setting(필터링 혹은 초기 param setting) > 렌더링 > 초기화 값 초기화
    initialization = false;
  }, [params]);

  // header 및 body 컬럼 커스텀
  const customized = {};

  const getAdexUserData = () => {
    getAdexUserList()
      .then((response) => {
        const { data } = response.data;
        setUserFilterList(data);
        setUserIndex(0);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /**
   * selectbox 필터 선택
   * @param {string} name
   * @param {*} value
   */
  const handleFilterChange = (name, index) => {
    if (name === 'userId') {
      setParams({
        ...params,
        [name]: userFilterList[index].USER_ID,
      });
      setUserIndex(index);
    }
  };

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    getInitParam = false;
    initialization = true;
    setParams(initParam);
  };

  /**
   * option 리스트 만들어주는 함수
   * @param {Array} data option list 만들 array
   * @param {string} optionLabelKey option에 나올 label key 값
   * @param {string} optionValueKey option value key 값
   */
  const makeOptionList = (data, optionLabelKey, optionValueKey) => {
    if (typeof data === 'undefined') {
      return [];
    }
    const result = [...data];
    const defaultOption = {};
    if (data.length === 0) {
      result.push(defaultOption);
    }

    return result;
  };

  const getParam = (newParams) => {
    getInitParam = true;
    setParams({
      ...params,
      ...newParams,
    });
  };

  return (
    <>
      <FilterWrap handleOnReset={handleOnReset}>
        <StatisticsCommonFilter
          initialization={initialization}
          getParam={getParam}
          noneExternalFilter={true}
          noneDisplayFilter={true}
        />
        <MbSelectbox
          key="userId"
          label={t('매체선택')}
          value={userIndex}
          name="userId"
          optionData={makeOptionList(userFilterList, 'CORP_NAME', 'USER_ID')}
          optionLabelKey="CORP_NAME"
          optionValueKey="USER_ID"
          handleOnchange={handleFilterChange}
          icon={false}
        />
      </FilterWrap>
      {getInitParam && (
        <>
          <TableContainer
            dataReqPromise={adexTransmitStatistics}
            params={{ ...params }}
            sort="desc"
            order="PB_CNT"
            dense={true}
            customized={customized}
            hasExcel
            hasTotal
          />
        </>
      )}
    </>
  );
};

export default TransmitStatistics;
